
import type { MobileAlertMessages } from '../../models'
import { defineComponent, getCurrentInstance, onMounted, ref } from 'vue'
import { UiModal } from '../keen-ui'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'MobileAlertModal',
  components: {
    UiModal,
    EpbText,
  },
  setup() {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const messages = ctx.proxy.$epb.messages.mobileAlert as MobileAlertMessages

    const baseClass = 'epb-mobile-alert-modal'

    const modal = ref(null)

    function onClose(): void {
      modal.value?.close()
    }

    onMounted(() => {
      modal.value?.open()
    })

    return {
      messages,
      baseClass,
      modal,
      onClose,
    }
  },
})
